import React, { useEffect, useRef, useState } from "react";
import styles from "./BestSellers.module.scss";
import Game from "components/Games/Game";
import GameList from "constants/GameList";
import { useNavigate } from 'react-router-dom';

import Slider from "react-slick";// Slick Carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "components/carouselStyles.css";

function Arrow({ className, style, onClick, pauseCarousel }) {
    return (
        <div
            className={className}
            style={{ ...style, display: "flex" }}
            onClick={() => {
                pauseCarousel();
                onClick();
            }}
        />
    );
}

export default function BestSellers() {
    const navigate = useNavigate();
    let sliderRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);

    const pauseCarousel = () => {
        console.log("PAUSING");
        setIsPaused(true);
        if (sliderRef.current) {
            sliderRef.current?.slickPause?.();
            sliderRef.current?.innerSlider?.slickPause?.();
           
        } else {
            console.log("No slider ref");
        }
    };

    const carouselSettings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        autoplay: !isPaused,
        autoplaySpeed: 2000,
        speed: isPaused ? 750 : 2000,
        cssEase: "linear",
        nextArrow: <Arrow pauseCarousel={pauseCarousel} />,
        prevArrow: <Arrow pauseCarousel={pauseCarousel} />,
    };

    return (
        <section className={styles.bestSellersSection}>
            <h2 style={{ textShadow: "2px 2px 4px rgba(0,0,0,0.5)" }}>awesome party games</h2>
            <div className={styles.carouselSection}>
                <button onClick={() => navigate("/shop")} className={`${styles.button} ${styles.small} ${styles.alternate}`}>
                    VIEW ALL
                </button>
                <Slider ref={sliderRef} className={styles.carousel} {...carouselSettings}>
                    {GameList.filter(x => x.bestSeller && x.enabled).map((g, i) => (
                        <div key={`game-${i}`} className={`${styles.gameWidth} container p-0`}>
                            <Game game={g} showAddToCart={true} />
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
}

